import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative w-full bg-dark pt-20 pb-16 overflow-hidden border-b border-dark-lighter" data-id="element-94">
      <div className="max-w-5xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-95">
        <FadeIn className="flex flex-col items-start z-10" data-id="element-96">
          <div className="inline-block border border-cyan-accent text-cyan-accent font-display uppercase tracking-widest text-sm px-3 py-1 mb-6" data-id="element-97">
            The 8-Minute Protocol
          </div>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] mb-6 uppercase" data-id="element-98">
            The "No-Gym" <br data-id="element-99" />
            <span className="text-cyan-accent" data-id="element-100">Mobility Matrix</span>
          </h1>
          <h2 className="text-xl md:text-2xl font-sans text-gray-300 font-light leading-relaxed mb-8" data-id="element-101">
            End Desk-Bound Sciatica and Neck Lock in 8 Minutes a Day.
          </h2>
          <p className="text-base text-gray-400 mb-10 border-l-2 border-cyan-accent pl-4" data-id="element-102">
            The "Micro-Release" Method for Professionals 40+ to Stop Shooting
            Leg Pain and Shoulder Stiffness Without Leaving Your Office Chair.
          </p>
          <CTAButton text="Download the Matrix Now" href="#pricing" className="w-full sm:w-auto" data-id="element-103" />
        </FadeIn>

        <FadeIn delay={0.2} className="relative z-10 flex justify-center lg:justify-end" data-id="element-104">
          <div className="relative w-full max-w-md" data-id="element-105">
            <div className="absolute inset-0 bg-cyan-accent opacity-20 blur-[100px] rounded-full" data-id="element-106"></div>
            <img src="https://cdn.magicpatterns.com/uploads/dtMoxRvMFF1mURYujBX31o/heylloyd-image-1774898318641.png" alt="The No-Gym Mobility Matrix on a tablet" className="relative z-10 w-full h-auto shadow-2xl border border-dark-lighter rounded-sm" data-id="element-107" />
          </div>
        </FadeIn>
      </div>
    </section>;
}